import { Services, getPrice } from '@sigma-frontend-libs/commons'

import { isEmpty, proxy } from '@/utils'

import render from './render'

const baseClass = 'priceRanges'

export default {
  name: 'PriceRanges',

  mixins: [ proxy({ type: 'array' }) ],

  props: {
    readonly: Boolean
  },

  data() {
    return {
      showDialog: false
    }
  },

  methods: {
    remove(index) {
      if (!isEmpty(index)) {
        this.proxy.splice(index, 1)
      } else {
        this.proxy = []
      }
    },

    getItemValue(item, field) {
      switch (field) {
        case 'key': return item.key
        case 'price': return getPrice(item.price)
        default: return item[field]
      }
    },
    getTagTooltip(item) {
      const fields = [ 'key', 'price' ]
      const result = fields.map(field => {
        return [
          this.getTranslate(`${Services.tariffs}.labels.${baseClass}.${field}`),
          this.getItemValue(item, field)
        ].join(': ')
      })

      return result.join('\n')
    }
  },

  render
}
